<script lang="ts" setup>
import { defineProps, defineEmits, computed } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

const props = defineProps({
  isShowButtonText: {
    type: Boolean,
    default: false
  },
  isRegisteredWatchLater: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["click"]);

const textColor = computed(() => {
  return props.isRegisteredWatchLater ? "text-gray-05" : "text-primary";
});

const buttonClass = computed(() => {
  return props.isShowButtonText
    ? "button-container"
    : "button-container-simple";
});

const iconSize = computed(() => {
  return props.isShowButtonText ? "14" : "20";
});

const onChangeWatchLater = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
  emit("click");
};
</script>

<template>
  <button :class="buttonClass" @click="onChangeWatchLater">
    <FeatherIcon icon="paperclip" :size="iconSize" :class="textColor" />
    <span
      v-if="isShowButtonText"
      class="text-size-12"
      :class="textColor"
      data-testid="watch-later-button-text"
      >あとで見る</span
    >
  </button>
</template>

<style lang="scss" scoped>
.button-container {
  display: flex;
  gap: 2px;
  align-items: center;
  min-width: 92px;
  height: 24px;
  padding: 4px 8px;
  background-color: $gray-02;
  border-radius: 14px;
}

.button-container-simple {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 4px 12px;
  border: 1px solid $gray-03;
  border-radius: 50%;
}
</style>
